import { useMemo } from 'react';
import { PiPlayCircleDuotone } from 'react-icons/pi';
import { FcLeftUp2 } from 'react-icons/fc';

import Node, { Button, NodeValue } from 'app/admin/optimizationPipelineV2/component/pipeline/nodes/base/Node';

import { useOptimizationPipeline } from 'app/admin/optimizationPipelineV2/component/pipeline/providers/OptimizationPipelineProvider';

function getBooleanMeta(value) {
    if (value === true) return { value: 'Yes', severity: 'success' };
    if (value === false) return { value: 'No', severity: 'error' };
    return { value: 'Missing', severity: 'warning' };
}

export default function EDTDynamicCheckNode(props) {
    const { optimizationPipelineDetail, optimizationPipelineDetailsLoading, optimizationPipelineDetailsLoaded, openPopup } = useOptimizationPipeline();

    const edtFinished = optimizationPipelineDetail?.edt_finished;
    const edtConverged = optimizationPipelineDetail?.edt_converged;
    const edtAlarm = optimizationPipelineDetail?.edt_alarm;

    const { isDynamicCheckOk, isBaseCaseSucceeded, isBestCaseSucceeded } = useMemo(() => ({
        isDynamicCheckOk: edtFinished === true && edtConverged === true && edtAlarm === false,
        isBaseCaseSucceeded: edtConverged === true,
        isBestCaseSucceeded: edtFinished === true
    }), [edtFinished, edtConverged, edtAlarm]);

    const dynamicCheckMeta = getBooleanMeta(isDynamicCheckOk);
    const baseMeta = getBooleanMeta(isBaseCaseSucceeded);
    const bestMeta = getBooleanMeta(isBestCaseSucceeded);

    return (
        <Node ref={props.anchorRef} title='EDT Dynamic Check' icon={PiPlayCircleDuotone} fit={props.fit} loading={optimizationPipelineDetailsLoading || !optimizationPipelineDetailsLoaded}>

            <div className='w-full flex flex-col gap-8'>

                <NodeValue label='Dynamic Check OK' value={dynamicCheckMeta.value} severity={dynamicCheckMeta.severity} />

                <NodeValue label='Base Case Succeeded' value={baseMeta.value} severity={baseMeta.severity} />

                <NodeValue label='Best Case Succeeded' value={bestMeta.value} severity={bestMeta.severity} />

                <div className='w-full flex flex-col gap-10'>

                    <Button genericType='HISTORY' onClick={() => { openPopup({ type: 'DYNAMIC_VALIDATION_HISTORY' }); }} />

                    <Button label='Run' icon={FcLeftUp2} onClick={() => { openPopup({ type: 'DYNAMIC_VALIDATION_SETTINGS' }); }} />

                </div>

            </div>

        </Node>
    );
}